import type { TypeTableColumn } from '@thefarmersfront/kitchen';

import { formatDate } from '~/utils/date';

import { DATE_FORMAT } from '~/constants';

import { joinOrDash } from './deliveryAgencyTableCells';

import type { TypeDeliveryAgencyOutboundUnitListItem } from '~/types/delivery-agency.types';

const getDeliveryAgencyOutboundUnitListColumnDefs = ({
  currentPage,
  pageSize,
}: {
  currentPage: number;
  pageSize: number;
}) => {
  const columnDefs: TypeTableColumn<TypeDeliveryAgencyOutboundUnitListItem>[] = [
    {
      id: 'rowNumber',
      header: 'No',
      cell: ({ row }) => row.index + 1 + currentPage * pageSize,
      size: 96,
      meta: { selection: true },
    },
    {
      accessorKey: 'estimatedDeliveryDate',
      header: '배송 예정일',
      size: 100,
      cell: ({ row }) => formatDate(row.original.estimatedDeliveryDate, DATE_FORMAT.DATE) ?? '-',
    },
    {
      accessorKey: 'outboundCode',
      header: '출고번호',
      size: 160,
    },
    {
      id: 'isOutboundUnitConfigurable',
      accessorFn: (row) => (row.isOutboundUnitConfigurable ? '설정 가능' : '설정 불가'),
      header: '합포 단위 설정 가능',
      size: 160,
    },
    {
      accessorKey: 'clientOrderCodes',
      header: '판매처 주문번호',
      minSize: 160,
      cell: ({ row }) => joinOrDash(row.original.clientOrderCodes),
      meta: { flex: true },
    },
    {
      accessorKey: 'shippingLabels',
      header: '운송장 번호',
      minSize: 160,
      cell: ({ row }) => row.original.shippingLabels?.join(', ') ?? '-',
      meta: { flex: true },
    },
    {
      accessorKey: 'ordererName',
      header: '주문자명',
      size: 100,
    },
    {
      accessorKey: 'receiverName',
      header: '수령자명',
      size: 100,
    },
    {
      id: 'deliveryType',
      accessorFn: (row) => row.deliveryType?.description,
      header: '배송 유형',
      size: 80,
    },
    {
      id: 'courierCodeCode',
      accessorFn: (row) => row.courierCodeCode?.description,
      header: '배송사',
      size: 88,
    },
  ];

  return { columnDefs };
};

export default getDeliveryAgencyOutboundUnitListColumnDefs;
